<!--详情页面-->
<template>
  <div>
  <el-dialog
    :title="pagetitle"
    :visible.sync="dialogSeeVisible"
    center
    :close-on-click-modal="false" :append-to-body="true"
    custom-class="max-dialog1256">
    <div ref="print1" style="width: 100%;margin: 0 auto;">
      <p :style="{display:showtitle1,textAlign:'center',fontSize:'18px',lineHeight:'40px'}">
        {{pagetitle}}
      </p>
      <div v-if="ticket&&!isprint" style="margin-left: 10px;float:left ">
        <el-tag  :key="tag"   v-for="tag in ticket?ticket.split(';'):[]" :disable-transitions="false" size="mini" style="margin-left: 5px">{{tag}}</el-tag>
      </div>
      <div style="width: 640px;margin: 0 auto;text-align: right;"><img :src="imgpath"/></div>
      <table cellspacing="0" cellpadding="0" border="0" style="border-collapse:collapse;width:100%;"
             class="print-table">
        <tr class="noborder" style="height:36px">
          <td align="right" style="width: 60px">订单号：</td>
          <td style="width: 200px;max-width: 200px">{{controlData.erpserial}}</td>
          <td align="right" style="width: 60px">时&nbsp;&nbsp;间：</td>
          <td>{{controlData.htqd||controlData.adddate}}</td>
          <td align="right" style="width: 60px">仓&nbsp;&nbsp;库：</td>
          <td style="width: 180px">
            <el-select v-model="form.cangkucode" size="mini" style="width: 100px" @change="getCangkuNameByCode">
              <el-option v-for="item in jxcstoreData" :key="item.cangkucode" :label="item.cangkuname" :value="item.cangkucode">
              </el-option>
            </el-select>
          </td>
        </tr>
        <tr class="noborder" style="height:36px">
          <td align="right">门&nbsp;&nbsp;店：</td>
          <td style="width: 200px;max-width: 200px"><span style="font-size: larger"><b>{{controlData.customername}}</b></span> {{controlData.customerserial}} {{controlData.shortname||''}}</td>
          <td align="right">地&nbsp;&nbsp;址：</td>
          <td>{{controlData.deliveryaddress}}</td>
          <td align="right">联系人：</td>
          <td><span>{{(controlData.linkman||"")+" " +((controlData.linkmantel&&controlData.linkmantel!='null')?controlData.linkmantel:'')}}</span>
          </td>
        </tr>
        <tr class="noborder" style="height: 36px">
          <td align="right">品牌：</td>
          <td><span style="font-size: larger"><b>{{pingpainame}}</b></span></td>
          <td align="right">备注：</td>
          <td >
            <el-input v-model="form.remark" size="mini"  style="width: 80%"></el-input>
          </td>
          <td align="right">GY.NO：</td>
          <td>
            <el-input v-model="form.tracknum" size="mini" placeholder="请填写供应商单号"  onfocus="this.select()" style="width: 80%"></el-input>
          </td>
        </tr>
        <tr class="noborder" style="height: 36px">
          <td align="right">采购需求：</td>
          <td colspan="5" style="border: none;height: 30px">
            <div v-html="getLiuYan(controlData.remark)">
            </div>
          </td>
        </tr>
        <tr>
          <td colspan="6" style="border:none;padding-top: 30px;vertical-align: top">
            <el-col :span="8">
            <el-card class="box-card">
              <div slot="header" class="clearfix">
                <span style="color: #20A0FF">需求明细</span>
                <span style="padding-left: 20px">总数：{{goodsTotalnum}}</span>
                <el-button type="warning" style="float: right" size="mini" @click="createDetail">生成商品明细</el-button>
                <el-dropdown  style="float: right" @command="jingjiadown"  >
                  <el-button type="warning" size="mini">导出</el-button>
                  <el-dropdown-menu slot="dropdown" style="font-size: larger">
                    <el-dropdown-item command="1">未设置价格的</el-dropdown-item>
                    <el-dropdown-item command="2">有价格的</el-dropdown-item>
                    <el-dropdown-item command="all">全部商品</el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </div>
              <el-table :data="goodsData" size="mini" stripe border  style="width:100%;" empty-text="门店未指定型号">
                <el-table-column
                  width="50"
                  label="序"
                  align="center">
                  <template slot-scope="scope">
                    {{1+scope.$index}}
                  </template>
                </el-table-column>
                <el-table-column prop="M"  align="left" header-align="center"   width="95" label="型号" :show-overflow-tooltip="true"></el-table-column>
                <el-table-column prop="C"  align="left" header-align="center"   width="70" label="色号" :show-overflow-tooltip="true"></el-table-column>
                <el-table-column prop="P"  align="left" header-align="center"   width="55" label="数量"></el-table-column>
                <el-table-column align="left" header-align="center" width="90" label="单价">
                  <template slot-scope="scope">
                    <el-tag v-if="scope.row.error==1&&scope.row.costprice" type="danger">缺色号</el-tag>
                    <el-tag v-if="scope.row.error==1&&!scope.row.costprice" type="danger">未设置</el-tag>
                    <span v-if="scope.row.error==2"> {{scope.row.costprice|numeric(2)}}</span>
                  </template>
                </el-table-column>
              </el-table>
            </el-card>
            </el-col>
            <el-col :span="16">
            <el-card class="box-card" style="width:96%;float: right">
              <div slot="header" class="clearfix">
                <span style="color: #20A0FF">订单明细</span>
                <span style="padding-left: 20px">总数：<b>{{sendTotalnum}}</b></span>
                <span style="padding-left: 20px">总价：<b>{{sendTotalmoney}}</b></span>
                <div style="float: right">
                <el-button type="warning" size="mini" @click="tableData=[]">清 空</el-button>
                <el-button type="success" v-on:click="addFrame" size="mini">增 加</el-button>
                <el-button type="success" v-on:click="jingjiaselect" size="mini">导 入</el-button>
                <!--<a href="./static/file/镜架开单导入模板.xlsx">导入模板</a>-->
                </div>
              </div>
              <el-table :data="tableData" size="mini" stripe border  style="width:100%;" empty-text="尚未录入型号">
                <el-table-column
                  width="50"
                  label="序"
                  align="center">
                  <template slot-scope="scope">
                    {{1+scope.$index}}
                  </template>
                </el-table-column>
                <el-table-column
                  prop="M"  align="left" header-align="center"   width="100" label="型号" :show-overflow-tooltip="true">
                </el-table-column>
                <el-table-column
                  prop="C"  align="left" header-align="center"   width="75" label="色号" :show-overflow-tooltip="true">
                </el-table-column>
                <el-table-column prop="store"  align="left" header-align="center"   width="80" label="库存">
                  <template slot-scope="scope">
                    <el-tag v-if="scope.row.P>0&&scope.row.P>scope.row.store" type="danger">{{scope.row.store}}</el-tag>
                    <span v-else>{{scope.row.store}}</span>
                  </template>
                </el-table-column>
                <el-table-column prop="P"  align="left" header-align="center"   width="80" label="数量">
                  <template slot-scope="scope">
                    <el-input-number v-model="scope.row.P" :controls="false" @change="subData" @focus="focus($event)" size="mini" style="width: 70px" :min="1"></el-input-number>
                  </template>
                </el-table-column>
                <el-table-column
                  prop="price"  align="left" header-align="center"   width="100" label="单价">
                  <template slot-scope="scope">{{scope.row.price}}
                    <!--<el-input-number v-model="scope.row.price" :controls="false" :precision="2" @change="subData" @focus="focus($event)" size="mini" style="width: 90px" :min="0"></el-input-number>-->
                  </template>
                </el-table-column>
                <el-table-column  align="left" header-align="center"   width="100" label="合计">
                  <template slot-scope="scope">
                   {{scope.row.P&&scope.row.price?parseFloat(scope.row.P*scope.row.price).toFixed(2):''}}
                  </template>
                </el-table-column>
                <el-table-column
                  label="操作"
                  align="left"
                  width="60"
                  header-align="center">
                  <template slot-scope="scope">
                    <i class="el-icon-remove-outline" style="font-size: 24px;cursor: pointer" @click="deleteFrame(scope.$index)"></i>
                  </template>
                </el-table-column>
              </el-table>
            </el-card>
            </el-col>
          </td>
        </tr>
        <tr class="noborder">
          <td colspan="6" style="height: 10px"></td>
        </tr>
        <tr class="noborder" style="height:30px">
          <td colspan="6">&nbsp;</td>
        </tr>
      </table>
    </div>
    <div slot="footer" class="dialog-footer no-print">
      <el-button @click="dialogSeeVisible = false" size="mini">取 消</el-button>
      <el-button type="primary" @click="delivergoods" class="qrbtn" :loading="loading">通知仓库</el-button>
      <el-button type="primary" @click="startbuy('all')" class="qrbtn" :loading="loading">全单采购</el-button>
      <el-button type="primary" @click="startbuy('store')" class="qrbtn" :loading="loading">部分采购</el-button>
      <input type="file" ref="fileupload" style="display: none;" @change="change1($event)"/>
      <MakeInventoryFrameAdd ref="MakeInventoryFrameAdd" @afterSelect="afterSelect"></MakeInventoryFrameAdd>
      <BatchBuyorderDetailEdit ref="BatchBuyorderDetailEdit" @bindGrid="afterbuy"></BatchBuyorderDetailEdit>
    </div>
  </el-dialog>
  </div>
</template>

<script>
  import {getRemark, getKHRemark,loadSpecFrame} from '@/plugin/ordercommon'
  import {cusandptbyind} from '@/api/set/jxcstore';
  import {saveframeorder,updatecangku,updateliuyan} from '@/api/set/csagreement';
  import BatchBuyorderDetailEdit from '../buyagreement/BatchBuyorderDetailEdit';
  import {listgoodsframe,goodsframebycatname,jingjiaupload} from '@/api/set/jxcgooddetail';
  import MakeInventoryFrameAdd from '../../warehouse/MakeInventoryFrameAdd';
  import {getFramelistwithstore} from '@/api/set/jxcresultstore'

  export default {
    name: 'CstagreementAddgoods',
    data() {
      return {
        startbuytype:'',
        jxcstoreData: [],
        loading: false,
        pagetitle: '',
        ticket: '',
        showtitle1: "none",
        tableData: [],
        goodsData:[],
        frameData:[],
        goodsTotalnum:0,
        sendTotalnum:0,
        sendTotalmoney:0,
        pingpainame:'',
        categorycode:'',
        categoryname:'',
        cangkuStore:[],
        userInfoModel: {},
        imgpath: '',
        dialogSeeVisible: false,
        isprint: false,
        form: {
          unitguid:'',
          erpserial:'',
          remark:'',
          tracknum: '',
          cangkucode:'',
          cangkuname:'',
          seedinfo:'',
          pcustomerserial:'',
          pcustomer:''
        },
        controlData: {},
      }
    },
    methods: {
      //复制商品明细
      createDetail() {
        this.tableData = [];
        var arr = []
        for (let i in this.goodsData) {
          if (this.goodsData[i].error == 2) {
            arr.push(this.goodsData[i]);
          }
        }
        this.afterSelect(arr);
      },
      //导出EXCEL
      jingjiadown(command) {
        var date = new Date();
        let header1 = ["品牌", "商品名称", "型号", "规格", "数量", "年份", "材质", "市场价", "供应链成本价", "供应商名称"];
        let column1 = ["PP", "seedname", "M", "C", "P", "goodyear", "material", "costprice"]
        var name = this.controlData.pname + this.controlData.erpserial;
        var arr = []
        if (command == 'all') arr = this.goodsData;
        else {
          for (let i in this.goodsData) {
            if (this.goodsData[i].error == command) {
              arr.push(this.goodsData[i]);
            }
          }
        }
        this.$exportExcel(header1, column1, arr, name);
      },
      //切换仓库
      getCangkuNameByCode(cangkucode) {
        for (let i in this.jxcstoreData) {
          if (this.jxcstoreData[i].cangkucode == this.form.cangkucode) {
            this.form.cangkuname = this.jxcstoreData[i].cangkuname;
            return;
          }
        }
        this.bindStore();
      },
      checkColor(colorList,color) {
        for (let key in colorList) { //检查色号是否存在
          if (colorList[key] == color.toUpperCase()) {
            return true;
          }
        }
        return false;
      },
      //导入镜架
      jingjiaselect(){
        this.$refs.fileupload.value = ""
        this.$refs.fileupload.click()
      },
      change1(event) {
        try {
          var reg = /(\.xls|\.xlsx)$/
          if (!reg.test(event.target.files[0].name)) {
            this.showError("只能导入.xls或者.xlsx的文件！")
            return
          }
          this.$importExcel(event.target.files[0], (data) => {
            var catename = this.categoryname;
            let arr = loadSpecFrame(data, this.categorycode, catename);
            if (!arr || arr.length == 0) return;
            var needAddRow = [];
            var loadTable = [];
            var delayloadTable = [];
            var models = '';
            for (let i in arr) {//导入的数据
              var packagesize = JSON.parse(arr[i].goodsframe);
              var row = {
                seedcode: arr[i].seedcode,
                seedname: arr[i].seedname,
                M: packagesize[0].model,
                C: packagesize[0].color,
                P: arr[i].minnumber,
                costprice: ''
              };
              //先匹配价格
              var goodsrow = this.frameData.find(o => o.model == row.M);//产品库中的价格  color:"黑;银灰"  model:"ZH6699"  costprice:299
              if (goodsrow) {
                row.costprice = goodsrow.costprice;
                row.seedcode = goodsrow.seedcode;
                row.seedname = goodsrow.seedname;
                var colors = goodsrow.color.split(';');
                if (!this.checkColor(colors, row.C)) {//不存在色号 需要导入
                  arr[i].relatedcategoryname = '';
                  arr[i].costprice = '';
                  arr[i].refsellprice = '';
                  needAddRow.push(arr[i]);
                }

                var infoGoods = this.goodsData.filter(o => o.error == 1 && o.M == row.M && o.C == row.C);//采购需求中明细
                for (let j in infoGoods) {
                  infoGoods[j].costprice = goodsrow.costprice;
                  infoGoods[j].seedcode = goodsrow.seedcode;
                  infoGoods[j].seedname = goodsrow.seedname;
                  infoGoods[j].goodyear = goodsrow.goodyear;
                  infoGoods[j].error = 2;
                }
                loadTable.push(row);
              } else {
                // if (!arr[i].refsellprice || arr[i].refsellprice <= 0) {
                //   this.showError("第" + (i + 1) + "行 市场价必填！")
                //   return
                // }
                // if (!arr[i].relatedcategoryname) {
                //   this.showError("第" + (i + 1) + "行 供应商名称必填！")
                //   return
                // }
                // if (!arr[i].costprice || arr[i].costprice <= 0) {
                //   this.showError("第" + (i + 1) + "行 供应链成本价必填！")
                //   return
                // }
                // needAddRow.push(arr[i]);
                if (models.indexOf(packagesize[0].model) == -1)
                  models += packagesize[0].model + '、';
                arr[i].PP = catename;
                arr[i].M = packagesize[0].model;
                arr[i].C = packagesize[0].color;
                delayloadTable.push(arr[i]);//延迟绑定的项
              }
            }
            if (loadTable.length > 0)
              this.afterSelect(loadTable);

            if (needAddRow.length > 0) {
              jingjiaupload({arr: JSON.stringify(needAddRow)}).then(response => {
                if (response.data.code != 0) {
                  this.showError(response.data.msg)
                  return;
                }
                //导入完成重新拉取商品
                listgoodsframe({
                  needprice: '1',
                  categorycode: this.categorycode,
                  filltemplate: 80,
                  customerserial: this.controlData.customerserial
                }).then(response => {
                  this.frameData = response.data.obj;
                  // for (let i in delayloadTable) {
                  //   var row = delayloadTable[i];
                  //   //匹配价格
                  //   var goodsrow = this.frameData.find(o => o.model == row.M);
                  //   if (goodsrow) {
                  //     row.costprice = goodsrow.costprice;
                  //     row.seedcode = goodsrow.seedcode;
                  //     row.seedname = goodsrow.seedname;
                  //
                  //     var infoGoods = this.goodsData.filter(o => o.error == 1 && o.M == row.M && o.C == row.C);
                  //     for (let j in infoGoods) {
                  //       infoGoods[j].costprice = goodsrow.costprice;
                  //       infoGoods[j].seedcode = goodsrow.seedcode;
                  //       infoGoods[j].seedname = goodsrow.seedname;
                  //       infoGoods[j].goodyear = goodsrow.goodyear;
                  //       infoGoods[j].error = 2;
                  //     }
                  //   }
                  // }
                  // this.afterSelect(delayloadTable);
                });
              });
            }
            if (delayloadTable.length > 0) {
              this.$confirm("以下型号未录入：" + models, '提示', {
                confirmButtonText: '导出',
                cancelButtonText: '取消',
                type: 'warning'
              }).then(() => {
                var date = new Date();
                let header1 = ["品牌", "商品名称", "型号", "规格", "数量", "年份", "产地", "材质", "市场价", "供应链成本价", "供应商名称"];
                let column1 = ["PP", "seedname2", "M", "C", "minnumber", "goodyear", "place", "material", "refsellprice", "costprice", "relatedcategoryname"]
                var name = this.controlData.pname + this.controlData.erpserial;
                this.$exportExcel(header1, column1, delayloadTable, name);
              }).catch(() => {
              });
            }
          });
        } catch (ee) {
          this.$message.error("导入失败")
        }
      },
      getTitle() {
        let result = [];
        let temp = localStorage.getItem("hpapi_userInfoModel")
        if (temp) {
          result += JSON.parse(temp).tenantname || ""
        }
        result += "销售订单"
        return result
      },
      getLiuYan(remark) {
        if (this.isprint) {
          return getKHRemark(remark);
        }
        return getRemark(remark);
      },
      initData(row) {
        this.loading = false;
        this.controlData = {};
        this.tableData = [];
        this.cangkuStore = [];
        this.dialogSeeVisible = true;
        this.form.erpserial = row.erpserial;
        this.form.unitguid = row.unitguid;
        this.form.remark='';
        this.form.tracknum='';
        this.form.pcustomerserial='';
        this.form.pcustomer='';
        this.imgpath = window.API_ROOT + "/api/avatar/getBarcode?content=" + row.erpserial;
        this.pagetitle = this.getTitle();
        this.controlData = row;
        this.goodsData = [];
        this.goodsTotalnum = 0;
        this.sendTotalmoney = 0;
        this.sendTotalnum = 0;
        this.categorycode = '002';
        var pingpainame = row.pname;
        this.pingpainame = row.pname;
        this.categoryname = pingpainame;
        if (row.pname && row.pname.indexOf(';') > -1) {
          var pingpaicode = row.pname.split(';')[0];
          pingpainame = row.pname.replace(pingpaicode + ';', '');
          this.pingpainame = pingpainame;
          this.categoryname = pingpainame;

          if (pingpaicode.startsWith('004')) {
            this.pingpainame += "老花镜";
            this.categorycode = '004';
          } else if (pingpaicode.startsWith('003')) {
            this.pingpainame += "太阳镜"
            this.categorycode = '003';
          } else this.pingpainame += "光学架";
        }

        this.frameData = [];
        goodsframebycatname({categoryname: pingpainame, categorycode: this.categorycode,customerserial:this.controlData.customerserial}).then(response => {
          if (response.data.code == 0) {
            this.frameData = response.data.obj;
            this.categorycode = response.data.categorycode;
            if (row.seedinfo) {
              var seeds = JSON.parse(row.seedinfo);
              this.goodsData = [];
              for (let i in seeds) {
                var gItem = {
                  PP: this.pingpainame,
                  goodyear: "",
                  M: seeds[i].M,
                  C: seeds[i].C,
                  P: seeds[i].P,
                  costprice: "",
                  seedcode: "",
                  seedname: this.pingpainame + seeds[i].M,
                  error: 1
                };
                this.goodsTotalnum += seeds[i].P;
                var goodsrow = this.frameData.find(o => o.model == seeds[i].M);
                if (goodsrow) {
                  gItem.seedcode = goodsrow.seedcode;
                  gItem.seedname = goodsrow.seedname;
                  gItem.goodyear = goodsrow.goodyear;
                  gItem.costprice = goodsrow.costprice;
                  //检查色号是否存在
                  var colors = goodsrow.color.split(';');
                  for (let key in colors) {
                    if (colors[key] == seeds[i].C.toUpperCase()) {
                      gItem.error = 2;
                    }
                  }
                }
                this.goodsData.push(gItem);
              }
              this.goodsData.sort(function (a, b) {
                if (a.error + a.M == b.error + b.M)
                  return a.C.localeCompare(b.C);
                else
                  return (a.error + a.M).localeCompare(b.error + b.M);
              });
            }


            this.bindStore();
          } else {
            this.showError('品牌不正确！');
            this.loading = true;
          }
        })
      },
      checkForm(){
        if (!this.form.cangkucode) {
          this.showError('仓库必选！');
          return false;
        }
        if (this.tableData.length == 0) {
          this.showError('请填写订单明细！');
          return false;
        }
        for (let i in this.tableData) {
          var row = this.tableData[i];
          if (!row.P || row.P <= 0) {
            this.showError('第' + (parseInt(i) + 1) + '行数量未填！');
            return false;
          }
          if (!row.price || row.price <= 0) {
            this.showError('第' + (parseInt(i) + 1) + '行缺少单价！');
            return false;
          }
          if (!row.seedcode) {
            this.showError('第' + (parseInt(i) + 1) + '行缺少商品编码！');
            return false;
          }
        }
        return true;
      },
      startbuy(type) {
        if (!this.checkForm()) return;
        this.startbuytype=type;
        var goodsArr = [];
        for (let i in this.tableData) {
          var item = this.tableData[i];
          var row = {
            seedcode: item.seedcode,
            seedname: item.seedname,
            color: item.C,
            model: item.M,
            categorycode: this.categorycode,
            totalnumber: parseInt(item.P),
            formproperty: '[{}]',
            packagesize: '{"M":"' + item.M + '","C":"' + item.C + '"}',
            onlycode: '',
            barcodes: []
          }
          if (type == 'all') {
            goodsArr.push(row);
          } else {
            row.totalnumber = parseInt(item.P) - (parseInt(item.store) > 0 ? parseInt(item.store) : 0);
            if (row.totalnumber > 0)
              goodsArr.push(row);
          }
        }
        this.$refs.BatchBuyorderDetailEdit.show(true);
        this.$refs.BatchBuyorderDetailEdit.initData({
          noeditpage: true,
          enableddetail: type == 'all',
          cangkucode: this.form.cangkucode,
          cangkuname: this.form.cangkuname,
          categorycode: this.categorycode,
          categoryname: this.categoryname,
          goodsdetail: goodsArr,
          saleerpserial: this.form.erpserial
        });
      },
      afterbuy(buyrow) {
        this.form.pcustomerserial=buyrow.pcustomerserial;
        this.form.pcustomer=buyrow.pcustomer;
        if (this.startbuytype != 'all') {//部分采购，修改备注
          var row = {
            liuyan: buyrow.erpserial,
            unitguid: this.form.unitguid,
            type: '部分采购'
          };
          updateliuyan(row).then(response => {
            this.afterhandle(2);
          });
        } else {
          this.afterhandle(1);
        }
      },
      delivergoods() {
        if(!this.checkForm()) return;
        this.afterhandle(2);
      },
      afterhandle(invoicesource){
        this.form.seedinfo = JSON.stringify(this.tableData);
        saveframeorder(this.form).then(reponse => {
          if (reponse.data.code == 0) {
            //通知仓库操作
            updatecangku({
              erpserial: this.form.erpserial,
              unitguid: this.form.unitguid,
              cangkucode: this.form.cangkucode,
              cangkuname: this.form.cangkuname,
              warehouse:'',
              warehousename:'',
              tracknum: this.form.tracknum.trim(),
              status: this.status,
              pcustomerserial:this.form.pcustomerserial,
              pcustomer: this.form.pcustomer,
              invoicesource: invoicesource,
              supplydetail: '',
              weidianids: null
            }).then(response => {
              this.$message({message: '通知仓库成功！', type: 'success'});
              this.dialogSeeVisible = false;
              this.$emit('print');
              this.$emit('bindGrid');
            })
          } else {
            this.showError(reponse.data.msg);
          }
        });
      },
      addFrame() {
        this.$refs.MakeInventoryFrameAdd.show(this.frameData, {
          cangkucode: this.form.cangkucode,
          cangkuname: this.form.cangkuname
        });
      },
      deleteFrame(index) {
        this.tableData.splice(index, 1)
        this.subData();
      },
      afterSelect(arr) {
        for (var i in arr) {
          var MandC = arr[i];
          var hasValue = false;
          for (var j in this.tableData) {
            if (MandC.M == this.tableData[j].M && MandC.C == this.tableData[j].C) {//在库存里的
              if (this.tableData[j].P == '' || this.tableData[j].P == null)
                this.tableData[j].P = 0;
              this.tableData[j].P += MandC.P;
              hasValue = true
              break;
            }
          }
          if (!hasValue) {
            var item = {
              "seedcode": MandC.seedcode,
              "seedname": MandC.seedname,
              "M": MandC.M,
              "C": MandC.C,
              "price": MandC.costprice > 0 ? MandC.costprice : 0,
              "P": MandC.P,
              "store":0
            };
            this.tableData.push(item);
          }
        }
        this.sortTable();
      },
      sortTable() {
        this.tableData.sort(function (a, b) {
          if (a.M == b.M)
            return a.C.localeCompare(b.C)
          else
            return a.M.localeCompare(b.M)
        })
        this.subData();
      },
      subData() {
        this.sendTotalmoney = 0;
        this.sendTotalnum = 0;
        for (let i in this.tableData) {
          var row = this.tableData[i];
          if (row.P)
            this.sendTotalnum += parseInt(row.P);
          if (row.P && row.price) {
            this.sendTotalmoney += parseFloat(row.P) * parseFloat(row.price);
          }
          row.store = 0;
          var packages = '{"M":"' + row.M + '","C":"' + row.C + '"}';
          var infoGoods = this.cangkuStore.filter(o => o.seedcode == row.seedcode && o.packagesize == packages);//采购需求中明细
          for (let j in infoGoods) {
            row.store += infoGoods[j].openbalnum + infoGoods[j].debitnum - infoGoods[j].creditnum - infoGoods[j].deliverying + infoGoods[j].transfernum;//库存数量
          }
        }
        this.sendTotalmoney = this.sendTotalmoney.toFixed(2);
      },
      bindStore() {
        let yearnow = new Date().getFullYear()
        let monthnow = new Date().getMonth() + 1
        getFramelistwithstore({
          seedcode: '',//产品分类（单选）
          categorycode: this.categorycode,//产品分类（单选）
          cangkucode: this.form.cangkucode,//选择的仓库（单选）
          minyear: yearnow,
          minmonth: monthnow,
          maxyear: yearnow,
          maxmonth: monthnow,
          nostock: 1, nobuynum: '1', nolimit: '1'
        }).then(resStore => {
          this.cangkuStore = resStore.data.obj
        }).catch((error) => {});
      },
      focus(event) {
        event.currentTarget.select();
      },
      showError(errorinfo) {
        this.$message({
          message: errorinfo,
          type: 'error'
        })
      },

    },
    mounted() {
      this.userInfoModel = JSON.parse(localStorage.getItem("hpapi_userInfoModel"))
      cusandptbyind().then(response => {
        this.jxcstoreData = response.data.obj
        if (this.jxcstoreData.length > 0) {
          this.form.cangkucode = this.jxcstoreData[0].cangkucode
          this.form.cangkuname = this.jxcstoreData[0].cangkuname
        }
      })
    },
    components: {
      MakeInventoryFrameAdd,
      BatchBuyorderDetailEdit
    },
  }
</script>

<style scoped>
  .query-table td {
    border: 1px solid #E0DFDF;
    vertical-align: center;
    height: 22px;
    line-height: 16px;
    padding: 2px;
    font-size: 12px;
  }

  .query-table td.content {
    text-align: center;
  }

  .noborder td {
    border: none;
    font-size: 12px;
  }


</style>



// WEBPACK FOOTER //
// src/components/testorder/cstagreement/CstagreementAddgoods.vue